import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_inventory_status_by_NameService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { statusName: string }): 
  Promise<{ result: { Id?: number, Name?: string } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.statusName)) {
      $missingRequiredInParams.push('\'statusName\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      statusName: string    }) {
        if(isNil($inParams.statusName)) {
          return true; 
        }
      return false;
    }
}
